export const defaultProfileImg = '/img/user-default.png';